//@flow
import moment from 'moment';
import React, { useCallback } from 'react';

import { FilterItem } from '../../../components';
import { DatePicker } from '../../../components/ant/DatePicker';
import Field from '../../../components/card/Field';
import { CommonFilter, type FilterProps } from '../../../components/hoc/common/handbook/CommonFilter';
import { formatDateTimeToISOString } from '../../../lib/helpers';

export type FederalHighwayFareParamsFilter = {
  startDate?: string,
  endDate?: string
};

export default (props: FilterProps<FederalHighwayFareParamsFilter>) => {
  const Filter = useCallback(
    (filterProps: $Shape<FilterProps<FederalHighwayFareParamsFilter>>) =>
      CommonFilter<FederalHighwayFareParamsFilter>({
        ...filterProps,
        ...props
      }),
    [props]
  );
  return (
    <Filter>
      {(values, changeValue) => (
        <>
          <FilterItem>
            <Field mBottomNone>
              <DatePicker
                size="small"
                placeholder="Дата начала"
                value={values.startDate ? moment(values.startDate) : undefined}
                format={'DD.MM.YYYY'}
                onChange={(value, dateString) => {
                  changeValue(
                    'startDate',
                    formatDateTimeToISOString(value, dateString) || undefined
                  );
                }}
              />
            </Field>
          </FilterItem>
          <FilterItem>
            <Field mBottomNone>
              <DatePicker
                size="small"
                placeholder="Дата окончания"
                value={values.endDate ? moment(values.endDate) : undefined}
                format={'DD.MM.YYYY'}
                onChange={(value, dateString) => {
                  changeValue(
                    'endDate',
                    formatDateTimeToISOString(value, dateString) || undefined
                  );
                }}
              />
            </Field>
          </FilterItem>
        </>
      )}
    </Filter>
  );
};
